import React, { useEffect, useState } from 'react';
import CampoNumero from './CampoNumero';
import MejorarFotoNuevaModal from './MejorarFotoNuevaModal';
import NuevaCategoriaServicioInline from './NuevaCategoriaServicioInline';
import FrasesRapidasModal from './FrasesRapidasModal';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { subirFoto } from '../services/fotosService';
import { mensajeAmigable } from '../utils/errores';
import { limpiarTexto } from '../utils/validacion';
import {
  crearServicio, actualizarServicio, generarCodigoServicio,
  obtenerCategoriasServicio, obtenerAdicionales, reemplazarAdicionales,
  obtenerFrasesAgrupadas, obtenerAdicionalesPredef,
} from '../services/serviciosService';
import { MODALIDADES_PRECIO, MODALIDADES_SERVICIO, UNIDADES_DURACION, formatoMoneda } from '../utils/servicios';
import { misMarcas } from '../services/marcasService';
import { optimizarFoto } from '../utils/imagen';

// Formulario para CREAR o EDITAR un servicio. Secciones claras (fotos, básicos,
// precio, características, incluye/no incluye, adicionales, catálogo) para no
// abrumar. Reutiliza fotos, IA de fotos y CampoNumero del resto de la app.

const P = 'var(--color-primario,#DB2777)';

const seccionStyle = { marginBottom: '18px', paddingBottom: '18px', borderBottom: '1px solid #F3F4F6' };
const labelStyle = { display: 'block', marginBottom: '4px', fontSize: '13px', fontWeight: 600, color: '#374151' };
const inputStyle = { width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };

function fotosDesde(servicio) {
  if (!servicio) return [];
  return [1, 2, 3, 4, 5].map((n) => servicio[`foto_${n}_url`]).filter(Boolean);
}

// Editor de listas (¿Qué incluye? / No incluye / Requisitos).
// `sugerencias` = frases rápidas guardadas por el negocio → se tocan para
// agregarlas con un clic, sin volver a escribirlas.
function ListaEditable({ titulo, icono, items, onCambio, placeholder, sugerencias = [] }) {
  const [texto, setTexto] = useState('');
  const seleccionados = items || [];
  const agregar = (valor) => {
    const v = String(valor).trim();
    if (!v || seleccionados.includes(v)) { setTexto(''); return; }
    onCambio([...seleccionados, v]);
    setTexto('');
  };
  const disponibles = sugerencias.filter((s) => !seleccionados.includes(s));
  return (
    <div>
      <label style={labelStyle}>{icono} {titulo}</label>
      {disponibles.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '8px' }}>
          {disponibles.map((s) => (
            <button key={s} type="button" onClick={() => agregar(s)}
              style={{ background: 'color-mix(in srgb, var(--color-primario,#DB2777) 7%, white)', border: `1px solid ${P}`, color: P, borderRadius: '999px', padding: '4px 11px', fontSize: '12.5px', fontWeight: 600, cursor: 'pointer' }}>
              + {s}
            </button>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', gap: '6px' }}>
        <input value={texto} maxLength={120} onChange={(e) => setTexto(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); agregar(texto); } }}
          placeholder={placeholder} style={{ ...inputStyle, flex: 1 }} />
        <button type="button" onClick={() => agregar(texto)}
          style={{ padding: '0 14px', borderRadius: '8px', border: `1px solid ${P}`, background: '#fff', color: P, fontWeight: 700, cursor: 'pointer' }}>+</button>
      </div>
      {seleccionados.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
          {seleccionados.map((it, i) => (
            <span key={i} style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#F3F4F6', borderRadius: '999px', padding: '4px 10px', fontSize: '12.5px', color: '#374151' }}>
              {it}
              <button type="button" onClick={() => onCambio(seleccionados.filter((_, j) => j !== i))}
                style={{ background: 'none', border: 'none', color: '#9CA3AF', cursor: 'pointer', fontSize: '13px', lineHeight: 1 }}>×</button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default function FormularioNuevoServicio({ servicio = null, onCerrar, onGuardado }) {
  const editando = !!servicio;
  const { negocio } = useAuth();
  const { mostrarToast } = useToast();
  const monedaNegocio = negocio?.moneda || 'L';

  const [form, setForm] = useState(() => ({
    nombre: servicio?.nombre || '',
    categoria: servicio?.categoria || '',
    descripcion_corta: servicio?.descripcion_corta || '',
    descripcion: servicio?.descripcion || '',
    modalidad_precio: servicio?.modalidad_precio || 'fijo',
    precio: servicio?.precio != null ? String(servicio.precio) : '',
    impuesto_pct: servicio?.impuesto_pct != null ? String(servicio.impuesto_pct) : '',
    moneda: servicio?.moneda || monedaNegocio,
    duracion_valor: servicio?.duracion_valor != null ? String(servicio.duracion_valor) : '',
    duracion_unidad: servicio?.duracion_unidad || 'horas',
    modalidad_servicio: servicio?.modalidad_servicio || 'presencial',
    cobertura: servicio?.cobertura || '',
    incluye: servicio?.incluye || [],
    no_incluye: servicio?.no_incluye || [],
    requisitos: servicio?.requisitos || [],
    condiciones: servicio?.condiciones || '',
    politica_cancelacion: servicio?.politica_cancelacion || '',
    requiere_cotizacion: servicio?.requiere_cotizacion || false,
    requiere_cita: servicio?.requiere_cita || false,
    activo: servicio?.activo !== false,
    visible_catalogo: servicio?.visible_catalogo !== false,
    destacado: servicio?.destacado || false,
    marca_id: servicio?.marca_id || '',
  }));

  const [categorias, setCategorias] = useState([]);
  const [mostrarNuevaCat, setMostrarNuevaCat] = useState(false);
  const [frases, setFrases] = useState({ incluye: [], no_incluye: [], requisito: [] });
  const [adicionalesPredef, setAdicionalesPredef] = useState([]);
  const [editarFrases, setEditarFrases] = useState(false);
  const [fotosUrl, setFotosUrl] = useState(fotosDesde(servicio)); // ya alojadas (edición + IA)
  const [fotosFile, setFotosFile] = useState([]);                 // nuevas por subir
  const [adicionales, setAdicionales] = useState([]);
  const [codigoPreview, setCodigoPreview] = useState(servicio?.codigo || '');
  const [imagenParaIA, setImagenParaIA] = useState(null);
  const [mostrarIA, setMostrarIA] = useState(false);
  const [subiendoIA, setSubiendoIA] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [marcas, setMarcas] = useState([]);

  const set = (campo, valor) => setForm((f) => ({ ...f, [campo]: valor }));
  const sinPrecio = form.modalidad_precio === 'cotizacion';
  const totalFotos = fotosUrl.length + fotosFile.length;

  useEffect(() => {
    obtenerCategoriasServicio().then(setCategorias).catch(() => {});
    // "Mis marcas" (sql/142): si el negocio tiene varias marcas, el servicio dice de cuál es.
    misMarcas().then((r) => setMarcas(r.marcas.filter((m) => m.activa !== false))).catch(() => {});
  }, []);

  // Frases y adicionales guardados por el negocio (para seleccionar con un clic).
  const cargarPlantillas = () => {
    obtenerFrasesAgrupadas()
      .then((g) => setFrases({
        incluye: g.incluye.map((f) => f.texto),
        no_incluye: g.no_incluye.map((f) => f.texto),
        requisito: g.requisito.map((f) => f.texto),
      }))
      .catch(() => {});
    obtenerAdicionalesPredef().then(setAdicionalesPredef).catch(() => {});
  };
  useEffect(() => { cargarPlantillas(); }, []);

  // Carga adicionales existentes al editar.
  useEffect(() => {
    if (editando && servicio?.id) {
      obtenerAdicionales(servicio.id)
        .then((lista) => setAdicionales(lista.map((a) => ({ nombre: a.nombre, precio: String(a.precio), impuesto_pct: String(a.impuesto_pct || '') }))))
        .catch(() => {});
    }
  }, [editando, servicio]);

  // Preview del código correlativo al elegir categoría (solo en creación).
  useEffect(() => {
    if (editando || !form.categoria) { if (!editando) setCodigoPreview(''); return; }
    let activo = true;
    generarCodigoServicio(form.categoria).then((c) => { if (activo) setCodigoPreview(c || ''); }).catch(() => {});
    return () => { activo = false; };
  }, [form.categoria, editando]);

  // Permite elegir VARIAS fotos de una sola vez (hasta completar 5), en el
  // orden en que se seleccionaron. Evita tener que subirlas una por una.
  const agregarFotosFiles = (fileList) => {
    const files = Array.from(fileList || []).filter(Boolean);
    if (files.length === 0) return;
    const espacio = 5 - totalFotos;
    if (espacio <= 0) { mostrarToast('Ya tienes 5 fotos, suficiente 😊', 'error'); return; }
    setFotosFile((prev) => [...prev, ...files.slice(0, espacio)]);
    if (files.length > espacio) mostrarToast(`Se agregaron ${espacio}. El máximo es 5 fotos.`, 'error');
  };

  const abrirIA = async () => {
    if (totalFotos >= 5) { mostrarToast('Ya tienes 5 fotos.', 'error'); return; }
    // Fuente para la IA: una foto ya alojada, o subir la primera nueva.
    if (fotosUrl[0]) { setImagenParaIA(fotosUrl[0]); setMostrarIA(true); return; }
    if (fotosFile[0]) {
      setSubiendoIA(true);
      try {
        const url = await subirFoto(fotosFile[0]);
        setFotosUrl((prev) => [...prev, url]);
        setFotosFile((prev) => prev.slice(1));
        setImagenParaIA(url);
        setMostrarIA(true);
      } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
      finally { setSubiendoIA(false); }
      return;
    }
    mostrarToast('Primero sube una foto para mejorarla con IA.', 'error');
  };

  const usarFotoIA = (url) => {
    setFotosUrl((prev) => (prev.length + fotosFile.length >= 5 ? prev : [...prev, url]));
    mostrarToast('Foto agregada ✨', 'exito');
  };

  const validar = () => {
    if (form.nombre.trim().length < 2) { mostrarToast('Escribe el nombre del servicio', 'error'); return false; }
    if (!sinPrecio && (form.precio === '' || Number(form.precio) < 0)) {
      mostrarToast('Escribe un precio (o elige "Bajo cotización")', 'error'); return false;
    }
    return true;
  };

  const guardar = async () => {
    if (!validar()) return;
    setGuardando(true);
    try {
      // Subir las fotos nuevas y combinar con las ya alojadas (máx 5).
      const subidas = [];
      for (const file of fotosFile) {
        // eslint-disable-next-line no-await-in-loop
        subidas.push(await subirFoto(file));
      }
      const todas = [...new Set([...fotosUrl, ...subidas].filter(Boolean))].slice(0, 5);
      const datos = {
        nombre: form.nombre.trim(),
        categoria: form.categoria || null,
        ...(marcas.length > 1 ? { marca_id: form.marca_id || null } : {}),
        descripcion_corta: form.descripcion_corta.trim() || null,
        descripcion: form.descripcion.trim() || null,
        modalidad_precio: form.modalidad_precio,
        precio: sinPrecio ? 0 : (Number(form.precio) || 0),
        impuesto_pct: Number(form.impuesto_pct) || 0,
        moneda: form.moneda || monedaNegocio,
        duracion_valor: form.duracion_valor === '' ? null : (Number(form.duracion_valor) || null),
        duracion_unidad: form.duracion_valor === '' ? null : form.duracion_unidad,
        modalidad_servicio: form.modalidad_servicio,
        cobertura: form.cobertura.trim() || null,
        incluye: form.incluye,
        no_incluye: form.no_incluye,
        requisitos: form.requisitos,
        condiciones: form.condiciones.trim() || null,
        politica_cancelacion: form.politica_cancelacion.trim() || null,
        requiere_cotizacion: form.requiere_cotizacion,
        requiere_cita: form.requiere_cita,
        activo: form.activo,
        visible_catalogo: form.visible_catalogo,
        destacado: form.destacado,
        foto_1_url: todas[0] || null,
        foto_2_url: todas[1] || null,
        foto_3_url: todas[2] || null,
        foto_4_url: todas[3] || null,
        foto_5_url: todas[4] || null,
      };

      let servicioId = servicio?.id;
      if (editando) {
        await actualizarServicio(servicio.id, datos);
      } else {
        const creado = await crearServicio(datos);
        servicioId = creado.id;
      }
      await reemplazarAdicionales(servicioId, adicionales);
      mostrarToast(editando ? 'Servicio actualizado ✅' : 'Servicio creado ✅', 'exito');
      onGuardado && onGuardado();
      onCerrar();
    } catch (e) {
      mostrarToast(mensajeAmigable(e), 'error');
    } finally {
      setGuardando(false);
    }
  };

  const quitarUrl = (u) => setFotosUrl((prev) => prev.filter((x) => x !== u));
  const quitarFile = (i) => setFotosFile((prev) => prev.filter((_, j) => j !== i));

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '14px' }} onClick={guardando ? undefined : onCerrar}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', padding: '24px', width: '560px', maxWidth: '100%', maxHeight: '92vh', overflowY: 'auto', boxSizing: 'border-box' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '18px' }}>
          <h2 style={{ margin: 0, color: P, fontSize: '20px' }}>{editando ? '✏️ Editar servicio' : '🧰 Nuevo servicio'}</h2>
          <button onClick={onCerrar} disabled={guardando} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#9CA3AF' }}>✕</button>
        </div>

        {/* Fotos */}
        <div style={seccionStyle}>
          <label style={labelStyle}>📸 Fotos del servicio (opcionales, hasta 5 · puedes elegir varias a la vez)</label>
          {totalFotos > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
              {fotosUrl.map((u) => (
                <div key={u} style={{ position: 'relative' }}>
                  <img src={optimizarFoto(u, 160)} alt="" style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #E5E7EB' }} />
                  <button type="button" onClick={() => quitarUrl(u)} style={{ position: 'absolute', top: '-6px', right: '-6px', width: '18px', height: '18px', borderRadius: '50%', border: 'none', background: '#B91C1C', color: '#fff', fontSize: '11px', cursor: 'pointer', lineHeight: 1 }}>×</button>
                </div>
              ))}
              {fotosFile.map((f, i) => (
                <div key={i} style={{ position: 'relative' }}>
                  <img src={URL.createObjectURL(f)} alt="" style={{ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '8px', border: '1px dashed #9CA3AF' }} />
                  <button type="button" onClick={() => quitarFile(i)} style={{ position: 'absolute', top: '-6px', right: '-6px', width: '18px', height: '18px', borderRadius: '50%', border: 'none', background: '#B91C1C', color: '#fff', fontSize: '11px', cursor: 'pointer', lineHeight: 1 }}>×</button>
                </div>
              ))}
            </div>
          )}
          {totalFotos < 5 && (
            <input type="file" accept="image/*" multiple disabled={guardando}
              onChange={(e) => { agregarFotosFiles(e.target.files); e.target.value = ''; }}
              style={{ width: '100%', padding: '8px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '13px', boxSizing: 'border-box' }} />
          )}
          {totalFotos > 0 && totalFotos < 5 && (
            <button type="button" onClick={abrirIA} disabled={subiendoIA}
              style={{ width: '100%', marginTop: '8px', padding: '11px', borderRadius: '10px', border: `1px dashed ${P}`, background: 'color-mix(in srgb, var(--color-primario,#DB2777) 6%, white)', color: P, fontSize: '14px', fontWeight: 700, cursor: subiendoIA ? 'wait' : 'pointer' }}>
              {subiendoIA ? '⏳ Preparando…' : '✨ Mejorar la foto con IA'}
            </button>
          )}
        </div>

        {/* Básicos */}
        <div style={seccionStyle}>
          <label style={labelStyle}>Nombre del servicio *</label>
          <input value={form.nombre} disabled={guardando} maxLength={120}
            onChange={(e) => set('nombre', limpiarTexto(e.target.value, 120))} style={{ ...inputStyle, marginBottom: '12px' }} placeholder="Ej. Paquete Roatán 3 días 2 noches" />

          <label style={labelStyle}>Categoría</label>
          <div style={{ display: 'flex', gap: '6px' }}>
            <select value={form.categoria} disabled={guardando} onChange={(e) => set('categoria', e.target.value)} style={{ ...inputStyle, flex: 1 }}>
              <option value="">Sin categoría</option>
              {categorias.map((c) => <option key={c.id} value={c.nombre}>{c.icono} {c.nombre}</option>)}
            </select>
            <button type="button" onClick={() => setMostrarNuevaCat(true)} disabled={guardando}
              style={{ padding: '0 14px', borderRadius: '8px', border: `1px solid ${P}`, background: '#fff', color: P, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>➕ Nueva</button>
          </div>
          {!editando && codigoPreview && (
            <div style={{ marginTop: '8px', padding: '8px 12px', background: '#EEF2FF', border: '1px solid #C7D2FE', borderRadius: '8px', fontSize: '13px', color: '#3730A3' }}>
              🏷️ Código que se le asignará: <strong>{codigoPreview}</strong>
            </div>
          )}

          {marcas.length > 1 && (
            <>
              <label style={{ ...labelStyle, marginTop: '12px' }}>¿De qué marca es?</label>
              <select value={form.marca_id} disabled={guardando} onChange={(e) => set('marca_id', e.target.value)} style={inputStyle}>
                <option value="">{marcas.find((m) => m.principal)?.nombre || 'Marca principal'} (principal)</option>
                {marcas.filter((m) => !m.principal).map((m) => <option key={m.id} value={m.id}>{m.nombre}</option>)}
              </select>
              <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '4px' }}>El agente de contenido de esa marca lo usa para sus ideas.</div>
            </>
          )}

          <label style={{ ...labelStyle, marginTop: '12px' }}>Descripción corta</label>
          <input value={form.descripcion_corta} disabled={guardando} maxLength={160}
            onChange={(e) => set('descripcion_corta', e.target.value)} style={{ ...inputStyle, marginBottom: '12px' }} placeholder="Una línea que resuma el servicio (para el catálogo)" />

          <label style={labelStyle}>Descripción completa</label>
          <textarea value={form.descripcion} disabled={guardando} rows={3} maxLength={1500}
            onChange={(e) => set('descripcion', e.target.value)} style={{ ...inputStyle, fontFamily: 'inherit', resize: 'vertical' }} placeholder="Detalle del servicio, qué ofrece, para quién…" />
        </div>

        {/* Precio */}
        <div style={seccionStyle}>
          <label style={labelStyle}>💵 Cómo se cobra</label>
          <select value={form.modalidad_precio} disabled={guardando} onChange={(e) => set('modalidad_precio', e.target.value)} style={{ ...inputStyle, marginBottom: '12px' }}>
            {MODALIDADES_PRECIO.map((m) => <option key={m.clave} value={m.clave}>{m.nombre}</option>)}
          </select>
          {!sinPrecio && (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              <CampoNumero etiqueta={`Precio (${form.moneda})`} valor={form.precio} prefijo={form.moneda} min={0}
                deshabilitado={guardando} onChange={(v) => set('precio', v)} placeholder="0.00" />
              <CampoNumero etiqueta="Impuesto" valor={form.impuesto_pct} sufijo="%" min={0} max={100}
                ayuda="Configurable según tu país" deshabilitado={guardando} onChange={(v) => set('impuesto_pct', v)} placeholder="0" />
            </div>
          )}
          {sinPrecio && (
            <p style={{ margin: 0, fontSize: '12.5px', color: '#6B7280' }}>Este servicio se ofrece <strong>bajo cotización</strong>: el precio se define al cotizar.</p>
          )}
        </div>

        {/* Características */}
        <div style={seccionStyle}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
            <div>
              <label style={labelStyle}>Duración estimada</label>
              <div style={{ display: 'flex', gap: '6px' }}>
                <div style={{ flex: 1 }}>
                  <CampoNumero valor={form.duracion_valor} min={0} deshabilitado={guardando}
                    onChange={(v) => set('duracion_valor', v)} placeholder="Ej. 2" />
                </div>
                <select value={form.duracion_unidad} disabled={guardando} onChange={(e) => set('duracion_unidad', e.target.value)} style={{ ...inputStyle, width: 'auto' }}>
                  {UNIDADES_DURACION.map((u) => <option key={u.clave} value={u.clave}>{u.nombre}</option>)}
                </select>
              </div>
            </div>
            <div>
              <label style={labelStyle}>Modalidad</label>
              <select value={form.modalidad_servicio} disabled={guardando} onChange={(e) => set('modalidad_servicio', e.target.value)} style={inputStyle}>
                {MODALIDADES_SERVICIO.map((m) => <option key={m.clave} value={m.clave}>{m.icono} {m.nombre}</option>)}
              </select>
            </div>
          </div>
          <label style={labelStyle}>Cobertura / zona (opcional)</label>
          <input value={form.cobertura} disabled={guardando} maxLength={120}
            onChange={(e) => set('cobertura', e.target.value)} style={{ ...inputStyle, marginBottom: '12px' }} placeholder="Ej. Todo Honduras, o Ciudad de Olanchito" />
          <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap' }}>
            <label style={{ fontSize: '13px', color: '#374151', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.requiere_cotizacion} disabled={guardando} onChange={(e) => set('requiere_cotizacion', e.target.checked)} /> Requiere cotización
            </label>
            <label style={{ fontSize: '13px', color: '#374151', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.requiere_cita} disabled={guardando} onChange={(e) => set('requiere_cita', e.target.checked)} /> Requiere cita
            </label>
          </div>
        </div>

        {/* Incluye / No incluye / Requisitos */}
        <div style={seccionStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
            <span style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>Detalle del servicio</span>
            <button type="button" onClick={() => setEditarFrases(true)}
              style={{ background: 'none', border: 'none', color: P, fontSize: '12.5px', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
              📋 Editar mis frases rápidas
            </button>
          </div>
          <div style={{ display: 'grid', gap: '14px' }}>
            <ListaEditable titulo="¿Qué incluye?" icono="✓" items={form.incluye} sugerencias={frases.incluye}
              onCambio={(v) => set('incluye', v)} placeholder="Ej. Traslados, Hospedaje…" />
            <ListaEditable titulo="No incluye" icono="✗" items={form.no_incluye} sugerencias={frases.no_incluye}
              onCambio={(v) => set('no_incluye', v)} placeholder="Ej. Comidas, Propinas…" />
            <ListaEditable titulo="Requisitos / info del cliente" icono="📋" items={form.requisitos} sugerencias={frases.requisito}
              onCambio={(v) => set('requisitos', v)} placeholder="Ej. Pasaporte vigente…" />
          </div>
        </div>

        {/* Adicionales */}
        <div style={seccionStyle}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <label style={labelStyle}>➕ Servicios adicionales (opcionales)</label>
            <button type="button" onClick={() => setEditarFrases(true)}
              style={{ background: 'none', border: 'none', color: P, fontSize: '12.5px', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }}>
              📋 Editar mis adicionales
            </button>
          </div>
          <p style={{ margin: '0 0 8px', fontSize: '12px', color: '#9CA3AF' }}>Extras que el cliente puede sumar (ej. seguro de viaje, upgrade, tour extra).</p>
          {(() => {
            const usados = adicionales.map((a) => (a.nombre || '').trim().toLowerCase());
            const disponibles = adicionalesPredef.filter((a) => !usados.includes((a.nombre || '').trim().toLowerCase()));
            return disponibles.length > 0 ? (
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginBottom: '10px' }}>
                {disponibles.map((a) => (
                  <button key={a.id} type="button"
                    onClick={() => setAdicionales([...adicionales, { nombre: a.nombre, precio: String(a.precio), impuesto_pct: String(a.impuesto_pct || '') }])}
                    style={{ background: '#FEF3C7', border: '1px solid #F59E0B', color: '#78350F', borderRadius: '999px', padding: '4px 11px', fontSize: '12.5px', fontWeight: 600, cursor: 'pointer' }}>
                    + {a.nombre} · {formatoMoneda(a.precio, form.moneda)}
                  </button>
                ))}
              </div>
            ) : null;
          })()}
          {adicionales.map((a, i) => (
            <div key={i} style={{ display: 'flex', gap: '6px', marginBottom: '6px' }}>
              <input value={a.nombre} disabled={guardando} maxLength={80} placeholder="Nombre del adicional"
                onChange={(e) => setAdicionales(adicionales.map((x, j) => j === i ? { ...x, nombre: e.target.value } : x))}
                style={{ ...inputStyle, flex: 2 }} />
              <div style={{ flex: 1 }}>
                <CampoNumero valor={a.precio} prefijo={form.moneda} min={0} deshabilitado={guardando}
                  onChange={(v) => setAdicionales(adicionales.map((x, j) => j === i ? { ...x, precio: v } : x))} placeholder="0.00" />
              </div>
              <button type="button" onClick={() => setAdicionales(adicionales.filter((_, j) => j !== i))}
                style={{ padding: '0 12px', borderRadius: '8px', border: '1px solid #FCA5A5', background: '#fff', color: '#DC2626', cursor: 'pointer' }}>🗑️</button>
            </div>
          ))}
          <button type="button" onClick={() => setAdicionales([...adicionales, { nombre: '', precio: '', impuesto_pct: '' }])} disabled={guardando}
            style={{ marginTop: '4px', padding: '8px 14px', borderRadius: '8px', border: `1px solid ${P}`, background: '#fff', color: P, fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}>➕ Agregar adicional</button>
        </div>

        {/* Condiciones */}
        <div style={seccionStyle}>
          <label style={labelStyle}>Condiciones (opcional)</label>
          <textarea value={form.condiciones} disabled={guardando} rows={2} maxLength={800}
            onChange={(e) => set('condiciones', e.target.value)} style={{ ...inputStyle, fontFamily: 'inherit', resize: 'vertical', marginBottom: '12px' }} placeholder="Forma de pago, anticipo, vigencia del precio…" />
          <label style={labelStyle}>Política de cancelación (opcional)</label>
          <textarea value={form.politica_cancelacion} disabled={guardando} rows={2} maxLength={800}
            onChange={(e) => set('politica_cancelacion', e.target.value)} style={{ ...inputStyle, fontFamily: 'inherit', resize: 'vertical' }} placeholder="Ej. Cancelación sin costo hasta 48h antes." />
        </div>

        {/* Catálogo */}
        <div style={{ ...seccionStyle, borderBottom: 'none' }}>
          <label style={labelStyle}>Catálogo</label>
          <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap' }}>
            <label style={{ fontSize: '13px', color: '#374151', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.activo} disabled={guardando} onChange={(e) => set('activo', e.target.checked)} /> Activo
            </label>
            <label style={{ fontSize: '13px', color: '#374151', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.visible_catalogo} disabled={guardando} onChange={(e) => set('visible_catalogo', e.target.checked)} /> Visible en catálogo
            </label>
            <label style={{ fontSize: '13px', color: '#374151', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
              <input type="checkbox" checked={form.destacado} disabled={guardando} onChange={(e) => set('destacado', e.target.checked)} /> Destacado
            </label>
          </div>
        </div>

        {guardando && (
          <div style={{ marginBottom: '12px', padding: '10px', background: '#FEF3C7', borderRadius: '8px', border: '1px solid #FCD34D', textAlign: 'center' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#92400E', fontWeight: 600 }}>⏳ Guardando servicio…</p>
          </div>
        )}
        <button onClick={guardar} disabled={guardando}
          style={{ width: '100%', padding: '14px', background: guardando ? '#9CA3AF' : P, color: '#fff', border: 'none', borderRadius: '10px', fontSize: '16px', fontWeight: 'bold', cursor: guardando ? 'not-allowed' : 'pointer' }}>
          {guardando ? '⏳ Guardando…' : (editando ? 'Guardar cambios' : 'Guardar servicio')}
        </button>
      </div>

      {mostrarNuevaCat && (
        <NuevaCategoriaServicioInline
          onCreada={(cat) => { setCategorias((prev) => [...prev, cat]); set('categoria', cat.nombre); setMostrarNuevaCat(false); }}
          onCerrar={() => setMostrarNuevaCat(false)}
        />
      )}

      {mostrarIA && imagenParaIA && (
        <MejorarFotoNuevaModal
          imagenUrl={imagenParaIA}
          datosProducto={{ nombre: form.nombre, categoria: form.categoria, descripcion: form.descripcion_corta }}
          agregadas={fotosUrl.length}
          onUsar={usarFotoIA}
          onCerrar={() => setMostrarIA(false)}
        />
      )}

      {editarFrases && (
        <FrasesRapidasModal onCambio={cargarPlantillas} onCerrar={() => { setEditarFrases(false); cargarPlantillas(); }} />
      )}
    </div>
  );
}
